import styled from 'styled-components';

export const ArticleListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
